import { getRefVariables } from '@shared/utils/formula.function';
import { ParserOptions } from 'expr-eval';
import { EFormTableColumn } from './eform.model';

export function parseColumnFormula(
  rawExp: string,
  source: keyof EFormTableColumn,
  target: keyof EFormTableColumn,
  referableColumns: EFormTableColumn[],
  error: 'ignore' | 'throw' = 'throw',
): string {
  let result = rawExp;
  const errorKeys: string[] = [];
  const uniqueRefs = getRefVariables(result);
  uniqueRefs.forEach((key) => {
    const matched = referableColumns.find(
      (field) => field[source] === key,
    );
    if (matched) {
      result = result.replaceAll(
        `{${key}}`,
        `{${matched[target]?.toString() || ''}}`,
      );
    } else {
      errorKeys.push(key);
    }
  });
  if (error === 'throw' && errorKeys.length) {
    throw new Error(
      `The references (${errorKeys.join(', ')}) not found.`,
    );
  }
  return result;
}

export function getReferableColumns(columns: EFormTableColumn[]) {
  return columns.filter((column) => isReferableColumn(column));
}

export function isReferableColumn(column: EFormTableColumn) {
  const calculableColumnType = {
    number: true,
    formula: true,
  } as Record<string, boolean>;
  const isCalculableType = calculableColumnType[column.columnType];
  if (isCalculableType) return true;
  const isChoiceType = ['dropdown', 'radio'].includes(
    column.columnType,
  );
  const isCalculableChoice = isChoiceType && column.isForCalculate;
  return isCalculableChoice;
}

export const EFORM_EXP_PARSER_OPTIONS: ParserOptions = {
  operators: {
    add: true,
    subtract: true,
    multiply: true,
    divide: true,
    power: true,

    // disabled
    comparison: false,
    concatenate: false,
    conditional: false,
    factorial: false,
    logical: false,
    remainder: false,
    sin: false,
    cos: false,
    tan: false,
    asin: false,
    acos: false,
    atan: false,
    sinh: false,
    cosh: false,
    tanh: false,
    asinh: false,
    acosh: false,
    atanh: false,
    sqrt: false,
    log: false,
    ln: false,
    lg: false,
    log10: false,
    abs: false,
    ceil: false,
    floor: false,
    round: false,
    trunc: false,
    exp: false,
    length: false,
    in: false,
    random: false,
    min: false,
    max: false,
    assignment: false,
    fndef: false,
    cbrt: false,
    expm1: false,
    log1p: false,
    sign: false,
    log2: false,
  },
};
